import { render, staticRenderFns } from "./PaymentFormInfo.vue?vue&type=template&id=20b99a3d&"
import script from "./PaymentFormInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentFormInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports